import React, { useState, useEffect } from "react";
import { toast } from "react-hot-toast";
import { MdDelete, MdEdit } from "react-icons/md";
import { useDispatch } from "react-redux";
import { deleteTodo, updateTodo } from "../slices/todoSlice";
import TodoModel from "./TodoModel";
import CheckButton from "./CheckButton";
import { motion } from "framer-motion";

const child = {
  hidden: {y: 20, opacity: 0},
  visible: {
    y: 0,
    opacity: 1,
  }
}

function TodoItem({ todo }) {
  const dispatch = useDispatch();
  const [checked, setChecked] = useState(false);
  const [updateModelOpen, setUpdateModelOpen] = useState(false);

  useEffect(() => {
    if (todo.status === "complete") {
      setChecked(true);
    } else {
      setChecked(false);
    }
  }, [todo.status]);

  const handleDelete = () => {
    dispatch(deleteTodo(todo.id));
    toast.success("Ta-Day deleted successfully!");
  };

  const handleUpdate = () => {
    setUpdateModelOpen(true);
  };

  const handleCheck = () => {
    setChecked(!checked);
    dispatch(
      updateTodo({...todo, status: checked ? 'incomplete' : 'complete'})
    );
  };

  return (
    <>
      <motion.div className="flex items-center justify-between p-[1rem] bg-white mb-[1.5rem] border-r-[4px] rounded" variants={child}>
        <div className="flex items-center justify-start gap-1">
          <CheckButton
            checked={checked}
            handleCheck={handleCheck}
          />
          <div className="flex-col overflow-hidden">
            <p className={todo.status === "complete" ? "line-through" : ""}>
              {todo.title}
            </p>
            <p className="block font-[1.2rem] -mt-[0.2rem]">{todo.time}</p>
          </div>
        </div>
        <div className="flex items-center justify-center gap-1">
          <div
            className="font-[2rem] p-[0.5rem] border-r-4 bg-gray-300 flex items-center justify-center cursor-pointer transition-colors duration-300 hover:bg-gray-400"
            onClick={() => handleDelete()}
            onKeyDown={() => handleDelete()}
            role="button"
            tabIndex={0}
          >
            <MdDelete />
          </div>
          <div
            className="font-[2rem] p-[0.5rem] border-r-3 bg-gray-300 flex items-center justify-center cursor-pointer transition-colors duration-300 hover:bg-gray-400"
            onClick={() => handleUpdate()}
            onKeyDown={() => handleUpdate()}
            role="button"
            tabIndex={0}
          >
            <MdEdit />
          </div>
        </div>
      </motion.div>
      <TodoModel
        todo={todo}
        type="update"
        modelOpen={updateModelOpen}
        setModelOpen={setUpdateModelOpen}
      />
    </>
  );
}

export default TodoItem;

// without the functions being invoked, the todo model wasn't opening since the buttons weren't technically calling the action!
